import React from "react";

const StatsIcon = ({ height, styles }) => {
  return (
    <svg
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.60329 7.20117H4.94043C4.54511 7.20117 4.2251 7.52117 4.2251 7.91649V11.1293H6.60329V7.20117V7.20117Z"
        stroke="#42464C"
        strokeWidth="0.941243"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.2668 4.3457H7.31299C6.91767 4.3457 6.59766 4.66573 6.59766 5.06106V11.1227H8.97587V5.06106C8.97587 4.66573 8.66212 4.3457 8.2668 4.3457Z"
        stroke="#42464C"
        strokeWidth="0.941243"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6431 8.26758H8.98022V11.1227H11.3584V8.98293C11.3522 8.58761 11.0321 8.26758 10.6431 8.26758Z"
        stroke="#42464C"
        strokeWidth="0.941243"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.90663 14.0089H9.6716C12.8091 14.0089 14.0641 12.7539 14.0641 9.61642V5.85145C14.0641 2.71397 12.8091 1.45898 9.6716 1.45898H5.90663C2.76915 1.45898 1.51416 2.71397 1.51416 5.85145V9.61642C1.51416 12.7539 2.76915 14.0089 5.90663 14.0089Z"
        stroke="#42464C"
        strokeWidth="1.31774"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default StatsIcon;
